<vs-card class="overflow-hidden">
  <vs-card-header
    [config]="{
      title: 'Commission',
      subtitle: 'View commission rates by policy and plan, based on the currently published rating matrix.'
    }"
    class="[&_h2]:!text-base [&_h2]:!text-gray-900"
  ></vs-card-header>

  <div class="p-4 space-y-4">
    <ws-commission-policy-plan-picker
      [distributorId]="distributor?.id ?? null"
      (planSelected)="onPlanSelected($event)"
    ></ws-commission-policy-plan-picker>

    <div *ngIf="selection && termElements.length > 0" class="max-w-xs space-y-1">
      <div class="text-xs text-gray-500">Term</div>
      <vs-select
        vsInput
        [value]="selectedTermId"
        [config]="{ placeholder: 'All terms' }"
        (valueChanges)="onTermChange($event)"
      >
        <li vs-select-option [value]="null">All terms</li>
        <li *ngFor="let term of termElements" vs-select-option [value]="term.id">{{ term.title }}</li>
      </vs-select>
    </div>

    <div *ngIf="!selection" class="p-4 text-sm text-gray-500 italic">
      Select a policy and plan to view its commission rates.
    </div>

    <div *ngIf="selection && loading" class="p-4 text-sm text-gray-500">Loading commission rates...</div>

    <div *ngIf="selection && !loading && error" class="p-4 text-sm text-red-600">
      Couldn't load commission rates. Please try again.
    </div>

    <div
      *ngIf="selection && !loading && !error && report && report.breakdown.length === 0 && report.rows.length === 0"
      class="p-4 text-sm text-gray-500 italic"
    >
      No commission rates found for this plan.
    </div>

    <div
      *ngIf="selection && !loading && !error && report && (report.breakdown.length > 0 || report.rows.length > 0)"
      class="space-y-6"
    >
      <div *ngFor="let group of groupedBreakdown" class="space-y-2">
        <h3 class="text-sm font-semibold text-gray-900 flex items-center gap-2">
          {{ group.feeTypeTitle }}
          <vs-badge theme="default">Separate</vs-badge>
        </h3>
        <div class="overflow-auto border rounded">
          <table class="w-full min-w-full text-xs border-collapse">
            <thead class="bg-slate-50 border-b">
              <tr>
                <th class="px-3 py-2 text-left font-semibold">Applies To</th>
                <th class="px-3 py-2 text-left font-semibold">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let line of group.lines; let rowIndex = index"
                class="border-t"
                [class.bg-gray-50]="rowIndex % 2 === 1"
              >
                <td class="px-3 py-2">
                  <span *ngFor="let value of line.dimensionValues; let last = last"
                    >{{ value.elementTitle }}{{ last ? '' : ', ' }}</span
                  >
                  <span *ngIf="line.dimensionValues.length > 0"> &mdash; </span>
                  <span>{{ line.source === 'base' ? 'All sales' : 'Your rate' }}</span>
                </td>
                <td class="px-3 py-2 font-medium">{{ line.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngFor="let group of groupedRows" class="space-y-2">
        <h3 class="text-sm font-semibold text-gray-900 flex items-center gap-2">
          {{ group.feeTypeTitle }}
          <vs-badge theme="info">Combined</vs-badge>
        </h3>
        <div class="overflow-auto border rounded">
          <table class="w-full min-w-full text-xs border-collapse">
            <thead class="bg-slate-50 border-b">
              <tr>
                <th class="px-3 py-2 text-left font-semibold">Applies To</th>
                <th class="px-3 py-2 text-left font-semibold">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let row of group.rows; let rowIndex = index"
                class="border-t"
                [class.bg-gray-50]="rowIndex % 2 === 1"
              >
                <td class="px-3 py-2">
                  <span *ngIf="row.dimensionValues.length === 0">All products</span>
                  <span *ngFor="let value of row.dimensionValues; let last = last"
                    >{{ value.elementTitle }}{{ last ? '' : ', ' }}</span
                  >
                </td>
                <td class="px-3 py-2 font-medium">{{ row.rule ?? row.total }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</vs-card>
